import AugmentedEmployeeCard from "./EmployeeCard";

export default AugmentedEmployeeCard;
